import React from 'react'
import styles from './News.module.scss'

interface Props {
	date: string
}

const ColoredDate: React.FC<Props> = props => {
	const d = new Date(props.date)

	const day = d.getDate()
	const month = d.getMonth() + 1
	const year = d.getFullYear()

	return (
		<div className={styles.date}>
			<span className={styles.dateDay}>{day < 10 ? '0' + day : day}.</span>
			<span className={styles.dateMonth}>
				{month < 10 ? '0' + month : month}.
			</span>
			<span className={styles.dateYear}>{year}</span>
		</div>
	)
}

export default ColoredDate
